import styled from 'styled-components';

export const UptimeCallbackErrorDiv = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
`;

export const CenteredLoaderDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;
